import { useState, useEffect, useCallback } from "react";

export function ImageCarousel({ images, interval = 5000 }) {
  const [i, setI] = useState(0);
  const go = useCallback((idx) => setI((idx + images.length) % images.length), [images.length]);

  useEffect(() => {
    if (images.length <= 1) return;
    const t = setInterval(() => setI((p) => (p + 1) % images.length), interval);
    return () => clearInterval(t);
  }, [images.length, interval]);

  return (
    <div className="relative rounded-3xl shadow-xl border border-slate-200 bg-white overflow-hidden" data-testid="hero-carousel">
      {/* browser-style top bar so the screenshots read as product previews */}
      <div className="flex items-center gap-1.5 px-4 h-9 bg-slate-100 border-b border-slate-200">
        <span className="h-2.5 w-2.5 rounded-full bg-[#f87171]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#fbbf24]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#34d399]" />
      </div>
      <div className="relative aspect-[16/10] bg-white">
        {images.map((img, idx) => (
          <img
            key={idx}
            src={img.src}
            alt={img.alt}
            data-testid={`carousel-image-${idx}`}
            className={`absolute inset-0 w-full h-full object-contain object-top transition-opacity duration-700 ease-in-out ${idx === i ? "opacity-100" : "opacity-0"}`}
          />
        ))}
      </div>
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {images.map((_, idx) => (
          <button
            key={idx}
            onClick={() => go(idx)}
            data-testid={`carousel-dot-${idx}`}
            aria-label={`Ir a la imagen ${idx + 1}`}
            className={`h-2 rounded-full transition-all duration-300 ${idx === i ? "w-6 bg-[#7FD498]" : "w-2 bg-slate-300 hover:bg-slate-400"}`}
          />
        ))}
      </div>
    </div>
  );
}
